import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const NoAttachmentProvidedIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 1.5C11.0711 1.5 12.75 3.17893 12.75 5.25V7.125C12.75 8.16053 13.5895 9 14.625 9H16.5C18.5711 9 20.25 10.6789 20.25 12.75V20.625C20.25 21.6605 19.4105 22.5 18.375 22.5H5.625C4.58947 22.5 3.75 21.6605 3.75 20.625V3.375C3.75 2.33947 4.58947 1.5 5.625 1.5H9ZM14.8389 11.7012C14.546 11.4083 14.0712 11.4083 13.7783 11.7012L12.1875 13.292L10.5967 11.7012C10.3038 11.4083 9.82903 11.4083 9.53613 11.7012C9.24333 11.9941 9.24327 12.4689 9.53613 12.7617L11.127 14.3525L9.53613 15.9434C9.24324 16.2363 9.24324 16.711 9.53613 17.0039C9.82903 17.2967 10.3038 17.2968 10.5967 17.0039L12.1875 15.4131L13.7783 17.0039C14.0712 17.2968 14.546 17.2967 14.8389 17.0039C15.1318 16.711 15.1318 16.2363 14.8389 15.9434L13.248 14.3525L14.8389 12.7617C15.1317 12.4688 15.1317 11.9941 14.8389 11.7012ZM12.9717 1.81543C16.3703 2.70336 19.0466 5.37966 19.9346 8.77832C19.014 7.98155 17.8131 7.5 16.5 7.5H14.625C14.4179 7.5 14.25 7.33211 14.25 7.125V5.25C14.25 3.93695 13.7684 2.736 12.9717 1.81543Z"
      fill="#4D5788"
    />
  </svg>
);

export default NoAttachmentProvidedIcon;
